define([
    'plugin?transport-service!edge/platform/transport/TransportDefaultService',
    'edge/platform/tracking/transport',
    'portalConfig'
], (Transport, trackingWrapper) => {
    return angular.module('edge.platform.transport', ['portal.config'])

        .factory('TransportService', trackingWrapper(Transport));
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/transport/module.js